function normalize(v) {
    const len = Math.hypot(v.x, v.y);
    if (!len) return { x: 0, y: 0 };
    return { x: v.x / len, y: v.y / len };
}

function perpendicular(v) {
    return { x: -v.y, y: v.x };
}

function isValidPolygon(coords) {
    if (!Array.isArray(coords) || coords.length !== 1) return false;

    const ring = coords[0];
    if (!Array.isArray(ring) || ring.length !== 5) return false;

    return ring.every(p =>
        Array.isArray(p) &&
        p.length === 2 &&
        isFinite(p[0]) &&
        isFinite(p[1])
    );
}


const DrawRectangle = {
    onSetup() {
        const dummy = [0, 0];

        const rectangle = this.newFeature({
            type: 'Feature',
            properties: {},
            geometry: {
                type: 'Polygon',
                coordinates: [[dummy, dummy, dummy, dummy, dummy]]
            }
        });

        this.addFeature(rectangle);

        return {
            rectangle,
            phase: 0,
            A: null,
            B: null
        };
    },

    onClick(state, e) {
        const p = [e.lngLat.lng, e.lngLat.lat];

        if (state.phase === 0) {
            state.A = p;
            state.phase = 1;
            return;
        }

        if (state.phase === 1) {
            state.B = p;
            state.phase = 2;
            return;
        }

        const geo = state.rectangle.toGeoJSON();

        if (!isValidPolygon(geo.geometry.coordinates)) {
            return;
        }

        try {
            this.map.fire('draw.create', {
                features: [geo]
            });

            this.changeMode('simple_select');
        }catch (e){
            console.error(e)
        }


    },

    onMouseMove(state, e) {
        const map = this.map;

        if (state.phase === 0) return;
        if (state.phase >= 1 && !Array.isArray(state.A)) return;
        if (state.phase >= 2 && !Array.isArray(state.B)) return;

        const cursor = [e.lngLat.lng, e.lngLat.lat];

        if (state.phase === 1) {
            if (!Array.isArray(cursor)) return;

            const coords = [
                state.A,
                cursor,
                cursor,
                state.A,
                state.A
            ];

            state.rectangle.setCoordinates([coords]);
            return;
        }

        if (state.phase === 2) {
            const A = map.project(state.A);
            const B = map.project(state.B);
            const C = map.project(cursor);

            if (
                !isFinite(A.x) || !isFinite(A.y) ||
                !isFinite(B.x) || !isFinite(B.y) ||
                !isFinite(C.x) || !isFinite(C.y)
            ) {
                return;
            }

            const AB = { x: B.x - A.x, y: B.y - A.y };
            if (Math.abs(AB.x) < 1e-6 && Math.abs(AB.y) < 1e-6) return;

            const len = Math.hypot(AB.x, AB.y);
            const dir = { x: AB.x / len, y: AB.y / len };
            const normal = { x: -dir.y, y: dir.x };

            const AC = { x: C.x - A.x, y: C.y - A.y };
            const h = AC.x * normal.x + AC.y * normal.y;

            if (!isFinite(h)) return;

            const A2 = { x: A.x + normal.x * h, y: A.y + normal.y * h };
            const B2 = { x: B.x + normal.x * h, y: B.y + normal.y * h };

            const pA2 = map.unproject(A2).toArray();
            const pB2 = map.unproject(B2).toArray();

            if (
                !isFinite(pA2[0]) || !isFinite(pA2[1]) ||
                !isFinite(pB2[0]) || !isFinite(pB2[1])
            ) {
                return;
            }

            const coords = [
                state.A,
                state.B,
                pB2,
                pA2,
                //state.A
            ];

            state.rectangle.setCoordinates([coords]);
        }
    },


    toDisplayFeatures(state, geojson, display) {
        display(geojson);
    }
};

export default DrawRectangle;
